<template>
  <div class="">
    <div class="py-1 flex" v-if="options.still">
      <span
        class="mr-5 text-sm pt-2 flex flex-col-reverse"
        v-for="item in radioOptions"
        :key="item.id"
      >
        <input
          type="radio"
          :id="'frame_type-' + item.id"
          name="frame_type"
          class="opacity-0"
          :value="item.id"
          :required="required"
          :checked="type == item.id"
          @input="updateFrameType"
          @blur="updateFrameType"
        />
        <label
          :for="'frame_type-' + item.id"
          class="flex items-center cursor-pointer"
        >
          <span
            class="flex justify-center items-center w-4 h-4 mr-1 rounded-full border border-grey"
          >
            <span class="w-2 h-2 inline-block rounded-full"></span>
          </span>
          <div v-text="item.label" class="leading-loose"></div>
        </label>
      </span>
    </div>
    <div class="py-1" v-if="isSpecific">
      <stacked-input
        :label="i18n.specific"
        :help="i18n.specific_help.replace(':min', options.specific.min)"
        :required="required"
        :error="errors.specific_frames || specificFormatError"
      >
        <textarea
          name="specific_frames"
          :placeholder="i18n.specific_placeholder"
          :required="required"
          :class="errors.specific_frames || specificFormatError ? 'danger' : ''"
          :value="specific_frames"
          @input="updateSpecificFrames"
          @blur="updateSpecificFrames"
        />
      </stacked-input>
    </div>
  </div>
</template>

<script>
import StackedInput from "../../../../Design/Forms/StackedInput";

export default {
  props: ["options", "i18n", "required", "value", "errors"],
  components: { StackedInput },
  data() {
    return { ...this.value };
  },
  computed: {
    radioOptions() {
      return [
        {
          id: "still",
          label: this.i18n.still,
        },
        {
          id: "specific",
          label: this.i18n.specific,
        },
      ];
    },
    isSpecific() {
      return this.type === "specific";
    },
    isSpecificValid() {
      if (!this.specific_frames) {
        return true;
      }

      let re = new RegExp("^(\\d{1,5}(-\\d{1,5})?,)*\\d{1,5}(,|-|-\\d+)?$");

      return this.isSpecific && re.test(this.specific_frames);
    },
    specificFormatError() {
      return (
        !this.isSpecificValid &&
        "Error in your frames list, please follow the " +
          this.i18n.specific_placeholder
      );
    },
  },

  methods: {
    updateFrameType(e) {
      this.type = e.target.value;
      this.$emit("input", {
        type: this.type,
        specific_frames: this.specific_frames,
      });
    },
    updateSpecificFrames(e) {
      this.specific_frames = e.target.value.replaceAll(" ", "");
      this.$emit("input", {
        type: this.type,
        specific_frames: this.specific_frames,
      });
    },
  },
};
</script>
